import { Box } from "@mui/material";
import React from "react";

import { AccountIntelligenceView } from "../components/AccountIntelligence";
import Sidebar from "../components/Layout/Sidebar";

const AccountIntelligencePage: React.FC = () => (
  <Box sx={{ display: "flex", height: "100vh", backgroundColor: "background.default", overflow: "hidden" }}>
    <Sidebar />
    <Box sx={{ flex: 1, height: "100%", overflow: "hidden", backgroundColor: "#1e1e1e" }}>
      <AccountIntelligenceView />
    </Box>
  </Box>
);

export default AccountIntelligencePage;
